import { computed, defineComponent, watch, ref, onMounted, } from '@vue/composition-api';
import { genericTableRowSize } from '@/components/Table/__new__/_components/TableCellGeneric';
import TableLoader from '@/views/_components/Table/TableLoader.vue';
import { useSurveyColumns } from '@/views/Brand/Surveys/_composables/use-survey-columns';
import { GenericAGTable } from '@/components/Table/AGTable/AGTable.vue';
import { getSurveysList } from '@/api/v2/requests/surveys';
import FloatingTextFilter from '@/components/Table/AGTable/_components/FloatingTextFilter.vue';
import FloatingSelectFilter from '@/components/Table/AGTable/_components/FloatingSelectFilter.vue';
import FloatingDatepickerFiler from '@/components/Table/AGTable/_components/FloatingDatepickerFilter.vue';
import TableFooter from '@/views/_components/Table/TableFooter.vue';
import { useTableQueryParams } from '@/components/Table/_composables/use-table-query-params';
import SurveyPreviewCell from './SurveyPreviewCell.vue';
import SurveyModal from '@/layouts/_components/Surveys/SurveyModal.vue';
import { useAuthUser } from '@/composables';
import { SystemRole } from '@/api/requests/users';
export default defineComponent({
    components: {
        TableFooter,
        TableLoader,
        // eslint-disable-next-line vue/no-unused-components
        FloatingTextFilter,
        // eslint-disable-next-line vue/no-unused-components
        FloatingSelectFilter,
        // eslint-disable-next-line vue/no-unused-components
        FloatingDatepickerFiler,
        // eslint-disable-next-line vue/no-unused-components
        SurveyPreviewCell,
        SurveyModal,
        AgTable: GenericAGTable(),
    },
    setup(props, ctx) {
        const params = ctx.root.$route.params;
        const isLoading = ref(false);
        const rows = ref([]);
        const totalCount = ref(0);
        const brandId = params.id;
        const agTableRef = ref(null);
        const showPreviewModal = ref(false);
        const selectedSurvey = ref(null);
        const { systemRole } = useAuthUser();
        const PREVIEW_ALLOWED_ROLES = [
            SystemRole.ADMIN,
            SystemRole.SUPER_ADMIN,
            SystemRole.EMPLOYEE,
            SystemRole.BRAND_ADMIN,
            SystemRole.STRUCTURE_MANAGER,
        ];
        const canPreview = computed(() => PREVIEW_ALLOWED_ROLES.includes(systemRole.value));
        const handlePreview = (survey) => {
            selectedSurvey.value = survey;
            showPreviewModal.value = true;
        };
        const { page, perPage, query: tableQuery, handleFilterChange: handleQueryFilterChange, handleSort, resetSort, } = useTableQueryParams(ctx, {
            defaultPerPage: 25,
            filterParams: {
                title: 'title',
                internalNumber: 'internalNumber',
                createdAt: 'createdAt',
            },
            fieldMap: {
                'user.place.internalNumber': 'placeNumber',
            },
            staticParams: {
                brandId,
            },
        });
        const query = computed(() => {
            return { ...tableQuery.value };
        });
        const fetchItems = async () => {
            isLoading.value = true;
            try {
                const { nodes, totalCount: nodesCount } = await getSurveysList(query.value ?? {});
                totalCount.value = nodesCount;
                rows.value = nodes;
            }
            catch (err) {
                ctx.root.$toast.error(ctx.root.$t(`brand-surveys.error-fetching-surveys`));
            }
            finally {
                isLoading.value = false;
            }
        };
        const changePage = (newPage) => {
            page.value = newPage;
        };
        const handleFilterChange = (filterModel) => {
            handleQueryFilterChange(filterModel);
        };
        const handleSortChange = (field, sort) => {
            handleSort(field, sort);
        };
        const handleResetSort = () => {
            resetSort();
        };
        const handlePerPageChange = (newPerPage) => {
            perPage.value = newPerPage;
            page.value = 1;
        };
        const closePreviewModal = () => {
            showPreviewModal.value = false;
            selectedSurvey.value = null;
        };
        onMounted(async () => {
            await fetchItems();
        });
        const { columns } = useSurveyColumns(ctx, {
            onPreview: handlePreview,
            canPreview: canPreview.value,
        });
        watch(query, () => {
            fetchItems();
        }, { deep: true });
        return {
            columns,
            tableQuery,
            page,
            perPage,
            totalCount,
            genericTableRowSize,
            rows,
            isLoading,
            handleFilterChange,
            handleSortChange,
            handleResetSort,
            changePage,
            handlePerPageChange,
            agTableRef,
            showPreviewModal,
            selectedSurvey,
            closePreviewModal,
        };
    },
});
